import { useQuery } from "@tanstack/react-query";
import { fetchReport } from "../services/reportService";

export const useReports = (page = 1) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["reports", page],
    queryFn: () => fetchReport(page),
    select: (response) => {
      return {
        reports: response.message?.reports?.data || [],
        reportStats: response.message || {},
        salesTrend: response.message?.sales_trend || {},
        customerGrowth: response.message?.customer_growth || {},
        salesByCategory: response.message?.sales_by_category || {},
        categoryDistribution: response.message?.category_distribution || {},
        topPerformingProducts: response.message?.top_performing_products || [],
      };
    },
  });

  return {
    reports: data?.reports || [],
    loading: isLoading,
    error: error?.message || null,
    reportStats: data?.reportStats || {},
    salesTrend: data?.salesTrend || {},
    customerGrowth: data?.customerGrowth || {},
    salesByCategory: data?.salesByCategory || {},
    categoryDistribution: data?.categoryDistribution || {},
    topPerformingProducts: data?.topPerformingProducts || [],
  };
};
